module.exports = __webpack_public_path__ + "static/media/logo_purp.7d2c2b34.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logo_purp.svg
// module id = 2141
// module chunks = 0